export const omit = (object: Record<string, unknown>, toOmit: string[]) => {
  let clone = {...object};
  toOmit.forEach((key) => {
    delete clone[key];
  })

  return {...clone}
}